export default __webpack_public_path__ + "static/media/nesto-online-cover-img1.4955487b.png";